import React, { useId } from "react";
import GoldSelect from "../GoldSelect";

/**
 * Select del sistema de UI: envuelve GoldSelect añadiendo label/error/helperText,
 * igual que Input, para que ambos se usen de forma consistente en formularios.
 * Props: mismas que GoldSelect + label, error, helperText, required.
 */
function Select({
  label,
  error,
  helperText,
  required = false,
  id,
  className = "",
  ...rest
}) {
  const autoId = useId();
  const selectId = id || autoId;

  return (
    <div className="sw-ui-field">
      {label && (
        <label htmlFor={selectId} className="sw-plbl">
          {label}
          {required && <span className="sw-ui-field-required"> *</span>}
        </label>
      )}
      <GoldSelect
        id={selectId}
        className={`${error ? "sw-ui-input--error" : ""} ${className}`}
        {...rest}
      />
      {(error || helperText) && (
        <p className={`sw-ui-field-hint ${error ? "sw-ui-field-hint--error" : ""}`}>
          {error || helperText}
        </p>
      )}
    </div>
  );
}

export default Select;
